import type { NextPageParams } from "@/schema"
import type { MeetingVersionSnapshot, MeetingVersionsResponse } from "@/schema/meeting-version"

import { apiContextFetch, type ApiContext } from "@/hooks/api/base"

export function fetchMeetingVersion(context: ApiContext, meetingId: string, versionId: string) {
  return apiContextFetch<MeetingVersionSnapshot>(context, `meetings/${meetingId}/versions/${versionId}`)
}

export function fetchMeetingVersions(context: ApiContext, meetingId: string, nextPageParams?: NextPageParams) {
  const params = new URLSearchParams()
  if (nextPageParams) {
    params.set("page", nextPageParams.page.toString())
    params.set("per_page", nextPageParams.per_page.toString())
  }
  return apiContextFetch<MeetingVersionsResponse>(context, `meetings/${meetingId}/versions?${params}`)
}
